var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9999C32 14.0428 31.648 12.168 31.0048 10.4348L16 9.73907L0.995188 10.4347C0.352063 12.168 0 14.0428 0 15.9999C0 17.9571 0.352063 19.8319 0.995188 21.5651L16 22.2608L31.0048 21.5652C31.648 19.8319 32 17.9571 32 15.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32C22.8796 32 28.7443 27.658 31.005 21.5652H0.995361C3.25605 27.658 9.12074 32 16.0002 32Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995361 10.4348H31.005C28.7443 4.342 22.8796 0 16.0002 0C9.12074 0 3.25605 4.342 0.995361 10.4348V10.4348Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.348 20.5217C13.8508 20.5217 11.8263 18.4972 11.8263 15.9999C11.8263 13.5027 13.8508 11.4782 16.348 11.4782C17.1267 11.4782 17.8593 11.6751 18.499 12.0217C17.4955 11.0404 16.1232 10.4347 14.6089 10.4347C11.5353 10.4347 9.0437 12.9263 9.0437 15.9999C9.0437 19.0734 11.5353 21.5651 14.6089 21.5651C16.1233 21.5651 17.4955 20.9594 18.499 19.9781C17.8593 20.3248 17.1267 20.5217 16.348 20.5217Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8262 12.8695L20.4252 14.5539L22.0398 13.7863L21.2722 15.4009L22.9567 15.9999L21.2722 16.5989L22.0398 18.2136L20.4252 17.4459L19.8262 19.1304L19.2274 17.4459L17.6127 18.2136L18.3803 16.5989L16.6958 15.9999L18.3803 15.4009L17.6127 13.7863L19.2274 14.5539L19.8262 12.8695Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/AZ.0d1fad98.svg";
export { ForwardRef as ReactComponent };